import React from 'react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Shield, FileText } from 'lucide-react';

export default function LegalPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <section className="section-padding bg-white" data-testid="legal-page">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#4A6B48]/10 mb-4">
              <Shield className="text-[#4A6B48]" size={40} />
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-[#2E332D] mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Mentions légales & propriété des données
            </h1>
            <p className="text-sm text-[#5C665A]">CRESA ASBL — Carrefour de Réflexion Santé</p>
          </div>
          <div className="space-y-6 text-[#2E332D]">
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>1. Éditeur du site</h2>
              <p className="text-sm leading-relaxed">
                Ce site est édité par <strong>CRESA ASBL</strong> (Carrefour de Réflexion Santé / Baraza la Afia),
                association sans but lucratif de droit congolais, N° JUST.112/S-KV/3917/2013,
                Avenue des Martyrs ex-VAMARO N° 05, Bukavu, République Démocratique du Congo.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>2. Propriété des données</h2>
              <div className="bg-[#4A6B48]/5 border-l-4 border-[#4A6B48] p-4 rounded">
                <p className="text-sm leading-relaxed">
                  <strong>Toutes les informations, contenus, données personnelles, fichiers, témoignages, candidatures
                  et contributions partagés sur ce site demeurent la propriété exclusive de CRESA ASBL.</strong> Aucune
                  cession ou revente à des tiers commerciaux n&apos;est effectuée. Les données sont utilisées
                  exclusivement dans le cadre de la mission statutaire de CRESA.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>3. Cookies & traçage</h2>
              <p className="text-sm leading-relaxed">
                Le site utilise un cookie technique pour la session (membres/admin), un cookie de préférence
                linguistique (Google Translate), et collecte des statistiques de visites anonymisées (pays, page,
                fréquence) sans identification personnelle.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>4. Droits d&apos;auteur</h2>
              <p className="text-sm leading-relaxed">
                Tous les textes, photos, vidéos, rapports et documents publiés sur ce site sont protégés par le
                droit d&apos;auteur. Toute reproduction commerciale est interdite sans autorisation écrite de CRESA ASBL.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>5. Vos droits</h2>
              <p className="text-sm leading-relaxed">
                Vous disposez d&apos;un droit d&apos;accès, de rectification et de suppression de vos données personnelles.
                Contactez l&apos;administration via le formulaire de contact ou par courrier postal au siège.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>6. Liens externes</h2>
              <p className="text-sm leading-relaxed">
                Les liens externes (bande-annonce d&apos;actualités, plateformes de crowdfunding, partenaires de recrutement)
                renvoient vers des contenus tiers dont CRESA ASBL n&apos;est ni l&apos;auteur ni le responsable.
              </p>
            </section>
            <section className="border-t border-[#E5E3DB] pt-6 mt-8">
              <p className="text-xs text-[#5C665A] italic flex items-center gap-2">
                <FileText size={14} />
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { dateStyle: 'long' })}
              </p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
